import ListHeader from "./list-header/list-header";
import ListHeaderMobile from "./list-header-mobile/list-header-mobile";
import ListPagination from "./list-pagination/list-pagination";
import ListTable from "./list-table/list-table";
import HeaderFullMobile from "./header-full-mobile/header-full-mobile";

const Lists = { ListHeader, ListHeaderMobile, ListPagination, ListTable, HeaderFullMobile };

export default Lists;
